import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useScreenMaster } from './ScreenMasterContext';

/** Blocks a route when its Screen Master module is disabled. */
export default function ScreenGate({ screenId, children, title }) {
  const { loading, isEnabled } = useScreenMaster();
  const { pathname } = useLocation();

  if (loading) {
    return (
      <div style={{ padding: '2rem', color: '#9aabbc' }}>
        Checking Screen Master…
      </div>
    );
  }

  if (!isEnabled(screenId)) {
    return (
      <div style={{
        maxWidth: 520,
        margin: '3rem auto',
        padding: '1.5rem',
        borderRadius: 12,
        border: '1px solid #2c3846',
        background: '#1a222c',
        color: '#e8eef4',
        fontFamily: 'Segoe UI, Trebuchet MS, sans-serif'
      }}
      >
        <h1 style={{ marginTop: 0, fontSize: '1.35rem' }}>{title || 'Screen disabled'}</h1>
        <p style={{ color: '#9aabbc', lineHeight: 1.45 }}>
          This screen is turned <strong>OFF</strong> in Screen Master.
          Frontend, APIs and backend bots for it are stopped.
        </p>
        <p style={{ color: '#7f91a3', fontSize: '0.9rem' }}>Path: {pathname}</p>
        <Link
          to="/ScreenMaster"
          style={{
            display: 'inline-block',
            marginTop: '0.75rem',
            padding: '0.5rem 0.9rem',
            borderRadius: 8,
            background: '#3d8bfd',
            color: '#fff',
            textDecoration: 'none'
          }}
        >
          Open Screen Master →
        </Link>
      </div>
    );
  }

  return children;
}
